import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import Confirm from '../../../../base/Confirm';
import ListView from '../../../../base/ListView';
import { dateRender } from '../../../../libs/utils';
import { SAFETY_QUESTIONS_ACTIONS } from '../../../../redux/safetyQuestions/actions';
import {
  safetyQuestionCreating,
  safetyQuestionsFilters,
  safetyQuestionsLoaded,
  safetyQuestionsMeta,
  selectActiveSafetyQuestion,
  selectSafetyQuestions,
} from '../../../../redux/safetyQuestions/selectors';
import SafetyQuestionsForm from '../../../forms/SafetyQuestionsForm';

class _SafetyQuestions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      safetyQuestions: this.props.safetyQuestions,
      safetyQuestionsLoaded: this.props.safetyQuestionsLoaded,
      baseFilters: {
        'page[number]': 1,
        'page[size]': 50,
        'sort': '-created_at',
      },
    };

    this._handleSubmit = this._handleSubmit.bind(this);
    this._handleDelete = this._handleDelete.bind(this);
    this._handleFilterUpdate = this._handleFilterUpdate.bind(this);
  }

  static propTypes = {
    safetyQuestions: PropTypes.array,
    safetyQuestionsLoaded: PropTypes.bool,
    match: PropTypes.object,
    createSafetyQuestion: PropTypes.func,
    updateSafetyQuestion: PropTypes.func,
    deleteSafetyQuestion: PropTypes.func,
    safetyQuestionCreating: PropTypes.bool,
    safetyQuestionsMeta: PropTypes.object,
    filters: PropTypes.object,
    loadSafetyQuestions: PropTypes.func,
    event: PropTypes.object,
    loadSafetyQuestion: PropTypes.func,
    activeSafetyQuestion: PropTypes.object,
    resetActive: PropTypes.func,
  };

  UNSAFE_componentWillMount() {
    this.props.loadSafetyQuestions(this.state.baseFilters, this.props.event.id);

    if (this.props.match.params.safetyQuestionId) {
      this.props.loadSafetyQuestion(this.props.match.params.safetyQuestionId, this.props.event.id);
    } else {
      this.props.resetActive();
    }
  }

  _handleFilterUpdate(filters) {
    this.props.loadSafetyQuestions(filters, this.props.event.id);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.match.params.safetyQuestionId !== nextProps.match.params.safetyQuestionId) {
      this.props.loadSafetyQuestion(nextProps.match.params.safetyQuestionId, this.props.event.id);
    }
  }

  _handleSubmit(values) {
    const data = {
      eventId: this.props.event.id,
      question: values.question,
      type: values.type,
      // adminReviewRequired: values.adminReviewRequired, // TODO: this doesn't work yet...
      adminReviewRequired: true,
      requiredRule: values.requiredRule,
    };

    if (this.props.match.params.safetyQuestionId) {
      this.props.updateSafetyQuestion(values.id, data);
    } else {
      this.props.createSafetyQuestion(data);
    }
  }

  _handleDelete(id) {
    Confirm(
      'Are you sure you want to delete this safetyQuestion? This action can not be undone, please make sure no festival is using this safetyQuestion.',
      {
        title: 'Delete SafetyQuestion',
        confirmStyle: 'btn-danger',
        confirmText: 'Delete',
      }
    ).then(
      (result) => {
        this.props.deleteSafetyQuestion(id);
      },
      (result) => {}
    );
  }

  render() {
    const { safetyQuestionsMeta, filters, safetyQuestionCreating, event, safetyQuestions, activeSafetyQuestion } =
      this.props;

    const typeTranslator = {
      text: 'Text',
      confirmation: 'Confirm',
      polar_question: 'Yes/No',
      file: 'File',
    };

    const listViewConf = {
      dataSet: safetyQuestions,
      dataMeta: safetyQuestionsMeta,
      columns: [
        {
          key: 'question',
          value: 'Question',
          sort: 'question',
          render: (item) => <div className="prose" dangerouslySetInnerHTML={{ __html: item.question }} />,
        },
        {
          key: 'type',
          value: 'Type',
          sort: 'type',
          render: (safetyQuestion) => typeTranslator[safetyQuestion.type],
        },
        {
          key: 'updatedAt',
          value: 'Updated',
          sort: 'updated_at',
          render: (safetyQuestion) => dateRender(safetyQuestion.updatedAt),
        },
      ],
      baseFilters: filters,
      filters: [
        {
          label: 'Name',
          icon: 'la-search',
          type: 'text',
          key: 'name',
        },
      ],
      actions: {
        deleteLink: true,
        editLink: true,
        detailsLink: false,

        deleteFunction: this._handleDelete,
      },
      url: '/admin/events/' + event.id + '/safety-questions',
    };

    return (
      <div className="row">
        <div className="col-xl-8">
          <ListView
            config={listViewConf}
            handleDelete={this._handleDelete}
            handleFilterUpdate={this._handleFilterUpdate}
          />
        </div>
        <div className="col-xl-4">
          <div className="m-portlet">
            <div className="m-portlet__head">
              <div className="m-portlet__head-caption">
                <div className="m-portlet__head-title">
                  <span className="m-portlet__head-icon">
                    <i className="flaticon-map-location" />
                  </span>
                  <h3 className="m-portlet__head-text">
                    {activeSafetyQuestion ? 'Edit Safety Question' : 'Create Safety Question'}
                  </h3>
                </div>
              </div>
            </div>
            <SafetyQuestionsForm
              onSubmit={this._handleSubmit}
              isCreating={safetyQuestionCreating}
              safetyQuestion={activeSafetyQuestion}
              event={event}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadSafetyQuestion: (id, filters, eventId) => dispatch(SAFETY_QUESTIONS_ACTIONS.loadRequest(id, filters, eventId)),
  resetActive: () => dispatch(SAFETY_QUESTIONS_ACTIONS.resetActive()),
  createSafetyQuestion: (values, eventId) => dispatch(SAFETY_QUESTIONS_ACTIONS.createRequest(values, eventId)),
  updateSafetyQuestion: (id, values, eventId) => dispatch(SAFETY_QUESTIONS_ACTIONS.updateRequest(id, values, eventId)),
  deleteSafetyQuestion: (id, eventId) => dispatch(SAFETY_QUESTIONS_ACTIONS.deleteRequest(id, eventId)),
  loadSafetyQuestions: (filters, eventId) => dispatch(SAFETY_QUESTIONS_ACTIONS.loadAllRequest(filters, eventId)),
});

const mapStateToProps = function (state) {
  return {
    safetyQuestions: selectSafetyQuestions(state),
    safetyQuestionsLoaded: safetyQuestionsLoaded(state),
    safetyQuestionCreating: safetyQuestionCreating(state),
    safetyQuestionsMeta: safetyQuestionsMeta(state),
    filters: safetyQuestionsFilters(state),
    activeSafetyQuestion: selectActiveSafetyQuestion(state),
  };
};

const SafetyQuestions = connect(mapStateToProps, mapDispatchToProps)(_SafetyQuestions);

export default SafetyQuestions;
